import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Modal from "@xo-union/tk-component-modals";
import styles from "./styles.css";
function SharedModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    wrapperClassName = _ref.wrapperClassName,
    containerClassName = _ref.containerClassName,
    children = _ref.children;
  var modalRef = useRef(null);
  var previousActiveElement = useRef(null);
  useEffect(function () {
    if (isOpen) {
      previousActiveElement.current = document.activeElement;
      if (modalRef.current) {
        modalRef.current.focus();
      }
    } else if (previousActiveElement.current) {
      previousActiveElement.current.focus();
    }
  }, [isOpen]);
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: containerClassName
  }, children)));
}
process.env.NODE_ENV !== "production" ? SharedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  wrapperClassName: PropTypes.string
} : void 0;
SharedModal.defaultProps = {
  containerClassName: '',
  wrapperClassName: ''
};
export default SharedModal;